import { render } from "./CardHeader.vue?vue&type=template&id=625afb5c"
import script from "./CardHeader.vue?vue&type=script&lang=js"
export * from "./CardHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/mdbvue/Components/CardHeader.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "625afb5c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('625afb5c', __exports__)) {
    api.reload('625afb5c', __exports__)
  }
  
  module.hot.accept("./CardHeader.vue?vue&type=template&id=625afb5c", () => {
    api.rerender('625afb5c', render)
  })

}


export default __exports__